import { MapInfoBoxTypeEnum } from './map-info-box-type.enum'

export interface IMapInfoBoxTypeSetup {
    headerClass?: string;
    tableClass?: string;
    header?: string;
    downloadAble?: boolean;
    propertyKey?: string;
}

export interface IInfoBoxTableRows {
    th: string;
    thColspan?: number;
    th2?: string;
    td: string;
    tdColspan?: number;
    td2?: string;
    newSection?: boolean;
    innerHtml?: boolean;
}

export const MapInfoBoxTypeSetup: Record<MapInfoBoxTypeEnum, IMapInfoBoxTypeSetup> = {
    [MapInfoBoxTypeEnum.lpis]: {
        headerClass: 'headerTwoRow',
        tableClass: 'fourColumns',
        downloadAble: true,
    },
    [MapInfoBoxTypeEnum.parcel]: {
        headerClass: 'headerTwoRow',
    },
    [MapInfoBoxTypeEnum.parcels_list]: {
        header: 'Vybrané parcely',
    },
    [MapInfoBoxTypeEnum.measure_distance]: {
        header: 'Měření vzdálenosti',
    },
    [MapInfoBoxTypeEnum.measure_area]: {
        header: 'Měření plochy a obvodu',
    },
    [MapInfoBoxTypeEnum.parcel_to_group]: {
        header: 'Přidání parcel do skupiny',
    },
    [MapInfoBoxTypeEnum.parcel_or_lpisv_search]: {
        header: 'Vyhledat půdní blok nebo parcelu',
    },
    [MapInfoBoxTypeEnum.building]: {
        header: 'Budova',
    },
    // Boxes shoved on separate position
    [MapInfoBoxTypeEnum.lpisUserSelection]: {
        header: 'Půdní bloky dle uživatelů',
        propertyKey: 'showedLpisUserSelection'
    },
    [MapInfoBoxTypeEnum.lpisEndingContract]: {
        header: 'Na končících smlouvách do data',
        propertyKey: 'showedLpisEndingContract'
    },
    [MapInfoBoxTypeEnum.parcelSelectByShapeDrawing]: {
        header: 'Nakreslit pomocí obrysu',
        propertyKey: 'showedParcelSelectByShapeDrawing'
    },
    [MapInfoBoxTypeEnum.parcelSelectByAddArea]: {
        header: 'Nakreslit přičítáním ploch',
        propertyKey: 'showedParcelSelectByAddArea'
    },
    [MapInfoBoxTypeEnum.parcelSplitting]: {
        header: 'Upravit plochu 1 podle výměry',
        propertyKey: 'showedParcelSplitting'
    },
}